import {
    SET_SELECTED_CAMPAIGN,
    SET_SELECTED_CAMPAIGN_ID,
    SET_SELECTED_SEGMENT,
    TOP_TAGS_REQUESTED,
    TOP_TAGS_SUCCEEDED,
    TOP_TAGS_FAILED,
    TOP_CONTRIBUTORS_REQUESTED,
    TOP_CONTRIBUTORS_SUCCEEDED,
    TOP_CONTRIBUTORS_FAILED,
    IMPACT_FILTER_REQUESTED,
    IMPACT_FILTER_SUCCEEDED,
    IMPACT_FILTER_FAILED,
    SPECIFIC_CAMPAIGN_REQUESTED,
    SPECIFIC_CAMPAIGN_SUCCEEDED,
    SPECIFIC_CAMPAIGN_FAILED,
    CONNECTED_CAMPAIGN_REQUESTED,
    CONNECTED_CAMPAIGN_SUCCEEDED,
    CONNECTED_CAMPAIGN_FAILED,
    SET_PARENT_CAMPAIGN,
} from './constants';

export function setSelectedChallengeId(challengeId) {
    return {
        type: SET_SELECTED_CAMPAIGN_ID,
        challengeId,
    };
}

export function setSelectedChallenge(challenge) {
    return {
        type: SET_SELECTED_CAMPAIGN,
        challenge,
    };
}

export function setSelectedSegment(segmentId) {
    return {
        type: SET_SELECTED_SEGMENT,
        segmentId,
    };
}

export function topContributorsRequested(date, customDate) {
    return {
        type: TOP_CONTRIBUTORS_REQUESTED,
        date,
        customDate,
    };
}

export function topContributorsSucceeded(topContributors) {
    return {
        type: TOP_CONTRIBUTORS_SUCCEEDED,
        topContributors,
    };
}

export function topContributorsFailed(error) {
    return {
        type: TOP_CONTRIBUTORS_FAILED,
        error,
    };
}

export function topTagsRequested(taxonomy) {
    return {
        type: TOP_TAGS_REQUESTED,
        taxonomy,
    };
}

export function topTagsSucceeded(topTags) {
    return {
        type: TOP_TAGS_SUCCEEDED,
        topTags,
    };
}

export function topTagsFailed(error) {
    return {
        type: TOP_TAGS_FAILED,
        error,
    };
}

export function impactFilterRequested(selectedFilter) {
    return {
        type: IMPACT_FILTER_REQUESTED,
        selectedFilter,
    };
}

export function impactFilterSucceeded(impactLitters) {
    return {
        type: IMPACT_FILTER_SUCCEEDED,
        impactLitters,
    };
}

export function impactFilterFailed(error) {
    return {
        type: IMPACT_FILTER_FAILED,
        error,
    };
}
export function challengeRequested(challengeId) {
    return {
        type: SPECIFIC_CAMPAIGN_REQUESTED,
        challengeId,
    };
}

export function challengeSucceeded(challenge) {
    return {
        type: SPECIFIC_CAMPAIGN_SUCCEEDED,
        challenge,
    };
}

export function challenegeFailed(error) {
    return {
        type: SPECIFIC_CAMPAIGN_FAILED,
        error,
    };
}

export function connectedChallengeRequested() {
    return {
        type: CONNECTED_CAMPAIGN_REQUESTED,
    };
}

export function connectedChallengeSucceeded(challenges) {
    return {
        type: CONNECTED_CAMPAIGN_SUCCEEDED,
        challenges,
    };
}

export function connectedChallenegeFailed(error) {
    return {
        type: CONNECTED_CAMPAIGN_FAILED,
        error,
    };
}

export function setParentChallenge(challenge) {
    return {
        type: SET_PARENT_CAMPAIGN,
        parentChallenge: challenge,
    };
}
